// @flow
import {
    login,
    receivedToken,
    checkLoginToken,
    logout,
    initiateLoginCheck
} from "./login.saga";
import { requestFeed } from "./feed.saga";
import { all } from "redux-saga/effects";
import {
    deleteCorrection,
    reportCorrection,
    submitComment,
    submitCorrection
} from "./correction.saga";
import { userSetupComplete } from "./userSetup.saga";
import { deletePost, reportPost, submitPost } from "./post.saga";
import {
    userPosts,
    userProfileInit,
    userCorrections
} from "./userProfile.saga";
import { saveProfile } from "./editProfile.saga";
import { fetchPost } from "./viewPost.saga";
import { toggleCorrectionReaction, togglePostReaction } from "./reaction.saga";
import {
    pollForNotifications,
    requestNotifications,
    requestOpenNotifications,
    setOpenedAtFlow,
    setViewedAtFlow
} from "./notifications.saga";
import { submitFeedback } from "./feedback.saga";

export function* rootSaga(getFirebase: Function): Iterable<*> {
    yield all([
        login(getFirebase),
        requestFeed(),
        receivedToken(),
        checkLoginToken(),
        logout(getFirebase),
        userSetupComplete(),
        submitPost(),
        submitCorrection(),
        userProfileInit(),
        userPosts(),
        userCorrections(),
        initiateLoginCheck(),
        saveProfile(),
        fetchPost(),
        toggleCorrectionReaction(),
        togglePostReaction(),
        submitComment(),
        deletePost(),
        reportPost(),
        deleteCorrection(),
        reportCorrection(),
        requestNotifications(),
        requestOpenNotifications(),
        setViewedAtFlow(),
        setOpenedAtFlow(),
        pollForNotifications(),
        submitFeedback()
    ]);
}



// WEBPACK FOOTER //
// ./src/sagas/sagas.js